/*!
 * ============================================================================
 *   Creative Innovation Center, LG ELECTRONICS INC., SEOUL, KOREA
 *   Copyright(c) 2018 by LG Electronics Inc.
 *
 *   Release Version : 1.24.6.5901
 * ============================================================================
 */
window.extidcapSecure = undefined;
window.extRegisteridcapCloseHandler = undefined;
window.extDisableidcapConsoleLog = true;
window.extWebWorker = undefined;
window.idcap = undefined;
if (idcap === undefined) {
	(function () {
		idcap = {
			API_VERSION: "1.24.6.5901"
		};
		var g = [],
		e = 0,
		i = [{
				command_id: "0",
				param_text: '{"command_id" : "0", "command" : "notify_sdk_version", "idcap_js_extension_version" : "1.24.6.5901"}'
			}
		],
		k = null,
		o = false,
		d = false,
		n = false,
		c = null,
		f = null,
		l = null,
		b = false,
		m = null,
		a = null;
		function j(r) {
			if (extDisableidcapConsoleLog !== true) {
				var t;
				if (r.length > 1024) {
					t = r.substring(0, 1024)
				} else {
					t = r
				}
				if (extWebWorker !== true) {
					console.log(t)
				}
			}
		}
		if (extDisableidcapConsoleLog === true) {
			if (extWebWorker !== true) {
				console.log("idcap console log is disabled")
			}
		} else {
			if (extWebWorker !== true) {
				console.log("idcap console log is enabled")
			}
		}
		j("check external value : extDisableidcapConsoleLog = " + extDisableidcapConsoleLog + ", extidcapSecure = " + extidcapSecure + ", extRegisteridcapCloseHandler = " + extRegisteridcapCloseHandler);
		function p() {
			var r = navigator.userAgent,
			t = r.match(/Windows/),
			s = r.match(/Macintosh/),
			u = r.match(/Mac OS X/);
			j("UA = '" + r + "'");
			if (t || s || u) {
				j("idcap websocket off");
				return true
			}
			return false
		}
		b = p();
		function h(r, x, s, y) {
			var v = "",
			t = "",
			u = "";
			u = x[r];
			try {
				v = s[u];
				t = typeof v
			} catch (w) {
				v = "<unknown value>";
				t = "unknown"
			}
			if (t === "function") {
				v = "{/*function*/}"
			} else {
				if (t === "object") {
					v = m("", v)
				} else {
					if (t === "string") {
						v = '"' + v + '"'
					}
				}
			}
			y += '"' + u + '" : ' + v;
			if (r < x.length - 1) {
				y += ", "
			}
			return y
		}
		m = function (u, s) {
			var t = 0,
			r = "",
			v = [],
			w = "";
			for (r in s) {
				if (s.hasOwnProperty(r)) {
					v.push(r)
				}
			}
			v.sort();
			for (t = 0; t < v.length; t += 1) {
				w = h(t, v, s, w)
			}
			return u + "{" + w + "}"
		};
		function q(v, u) {
			if (extWebWorker !== true) {
				var t = "",
				s = v,
				r = document.createEvent("HTMLEvents");
				j(m("event received, ", u));
				r.initEvent(s, true, false);
				for (t in u) {
					if (u.hasOwnProperty(t)) {
						r[t] = u[t]
					}
				}
				//EventBus.$emit('test', key)
                //console.log('Event Dispatched')
                //console.log(r)
                //console.log(u)
				document.dispatchEvent(r)
			}
		}
		c = function () {
			if (d) {
				j("websocket : connection is in progress");
				return
			}
			d = true;
			if (extidcapSecure !== true) {
				j("default idcap connection");
				k = new WebSocket("ws://127.0.0.1:8053/idcap_command")
			} else {
				j("secure idcap connection");
				k = new WebSocket("wss://localhost:8054/idcap_command")
			}
			k.onopen = function () {
				j("websocket : onopen");
				d = false;
				o = true;
				setTimeout(f, 5)
			};
			k.onmessage = function (r) {
				var w = JSON.parse(r.data),
				s = w.command_id,
				v = w.command,
				u = w.result;
				if (s === "event") {
					if (v === "debug_event_received") {
						if (w.enable_log) {
							if (extWebWorker !== true) {
								console.log("idcap console log is enabled")
							}
						} else {
							if (extWebWorker !== true) {
								console.log("idcap console log is disabled")
							}
						}
						extDisableidcapConsoleLog = !w.enable_log
					} else {
						q(v, w)
					}
				} else {
					if (i.length > 0 && i[0].command_id === s) {
						j(m("command_id = " + s + " received, ", w));
						if (u) {
							if (i[0].onSuccess) {
								try {
									i[0].onSuccess(w)
								} catch (t) {
									j(m("exception : onSuccess : " + t))
								}
							}
						} else {
							if (i[0].onFailure) {
								try {
									i[0].onFailure(w)
								} catch (t) {
									j(m("exception : onFailure : " + t))
								}
							}
						}
						i.splice(0, 1);
						n = false;
						f()
					} else {
						j(m("invalid response from server ", w));
						n = false;
						f()
					}
				}
			};
			k.onclose = function () {
				j("websocket : onclose");
				d = false;
				o = false;
				n = false;
				setTimeout(f, 50)
			};
			if (extRegisteridcapCloseHandler === "onbeforeunload") {
				window.onbeforeunload = function () {
					j("close idcap websocket in onbeforeunload handler");
					k.onclose = function () {
						return undefined
					};
					k.close()
				}
			} else {
				if (extRegisteridcapCloseHandler === "onunload") {
					window.onunload = function () {
						j("close idcap websocket in onunload handler");
						k.onclose = function () {
							return undefined
						};
						k.close()
					}
				}
			}
		};
		f = function () {
			if (n) {
				return
			}
			n = true;
			if (o) {
				if (i.length > 0) {
					j(m("command_id = " + i[0].command_id + " sent, ", JSON.parse(i[0].param_text)));
					k.send(i[0].param_text);
					return
				}
			} else {
				c()
			}
			n = false
		};
		l = function (u, t) {
			if (u === null || u === "" || u === undefined) {
				j('[ERROR] command should not null or empty string! command === null || command === "" || command === undefined');
				return
			}
			if (Object.prototype.toString.call(t) === "[object Array]") {
				j("[ERROR] param should be Object type({})! param is Array. command = " + u);
				return
			}
			if (t === null || t === undefined) {
				j("[ERROR] param should be Object type({})! param === null || param === undefined. command = " + u);
				return
			}
			if (b) {
				if (t.onFailure) {
					t.onFailure({
						errorMessage: "idcap WebSocket is not available in this browser"
					})
				}
				return
			}
			if (e > 1024) {
				e = 0
			} else {
				e += 1
			}
			var r = e.toString(),
			s = "";
			t.command_id = r;
			t.command = u;
			s = JSON.stringify(t, null);
			i[i.length] = {
				command_id: r,
				param_text: s,
				onSuccess: t.onSuccess,
				onFailure: t.onFailure
			};
			j(m("command_id = " + r + " added, ", i[i.length - 1]));
			f()
		};
		if (!b) {
			setTimeout(f, 200)
		}
		idcap.preloadedApplication = {};
		idcap.preloadedApplication.getPreloadedApplicationList = function (r) {
			l("get_preloaded_application_list", r)
		};
		idcap.preloadedApplication.launchPreloadedApplication = function (r) {
			l("launch_preloaded_application", r)
		};
		idcap.preloadedApplication.destroyPreloadedApplication = function (r) {
			l("destroy_preloaded_application", r)
		};
		idcap.application = {};
		idcap.application.getServiceXml = function (r) {
			l("get_service_xml", r)
		};
		idcap.application.getDefaultServiceXml = function (r) {
			l("get_default_service_xml", r)
		};
		idcap.application.getApplicationList = function (r) {
			l("get_application_list", r)
		};
		idcap.application.launchApplication = function (r) {
			l("launch_application", r)
		};
		idcap.application.destroyApplication = function (r) {
			l("destroy_application", r)
		};
		idcap.application.installApplications = function (r) {
			l("install_applications", r)
		};
		idcap.application.removeApplications = function (r) {
			l("remove_applications", r)
		};
		idcap.application.RegisterSIApplicationList = function (r) {
			l("register_si_app_list", r)
		};
		idcap.video = {};
		idcap.video.getVideoSize = function (r) {
			l("get_video_size", r)
		};
		idcap.video.setVideoSize = function (r) {
			l("set_video_size", r)
		};
		idcap.video.getOsdTransparencyLevel = function (r) {
			l("get_osd_transparency_level", r)
		};
		idcap.video.setOsdTransparencyLevel = function (r) {
			l("set_osd_transparency_level", r)
		};
		idcap.video.isVideoMute = function (r) {
			l("get_video_mute", r)
		};
		idcap.video.setVideoMute = function (r) {
			l("set_video_mute", r)
		};
		idcap.volume = {};
		idcap.volume.getVolumeLevel = function (r) {
			l("get_volume_level", r)
		};
		idcap.volume.setVolumeLevel = function (r) {
			l("set_volume_level", r)
		};
		idcap.volume.getExternalSpeakerVolumeLevel = function (r) {
			l("get_external_speaker_volume_level", r)
		};
		idcap.volume.setExternalSpeakerVolumeLevel = function (r) {
			l("set_external_speaker_volume_level", r)
		};
		idcap.volume.getHeadphoneVolumeLevel = function (r) {
			l("get_headphone_volume_level", r)
		};
		idcap.volume.setHeadphoneVolumeLevel = function (r) {
			l("set_headphone_volume_level", r)
		};
		idcap.volume.setHealthcareHeadphoneMode = function (r) {
			l("set_healthcare_headphone_mode", r)
		};
		idcap.volume.getHealthcareHeadphoneMode = function (r) {
			l("get_healthcare_headphone_mode", r)
		};
		idcap.channel = {};
		idcap.channel.NO_STREAM_PID = 8191;
		idcap.channel.ChannelType = {
			UNKNOWN: 0,
			RF: 1,
			IP: 2,
			RF_DATA: 3,
			IP_DATA: 4
		};
		idcap.channel.Polarization = {
			UNKNOWN: 0,
			VERTICAL: 1,
			HORIZONTAL: 2,
			LEFT_HAND_CIRCULAR: 3,
			RIGHT_HAND_CIRCULAR: 4
		};
		idcap.channel.RfBroadcastType = {
			UNKNOWN: 0,
			TERRESTRIAL: 16,
			TERRESTRIAL_2: 17,
			SATELLITE: 32,
			SATELLITE_2: 33,
			SATELLITE_CS1: 34,
			SATELLITE_CS2: 35,
			SATELLITE_S3_BS: 36,
			SATELLITE_S3_CS: 37,
			CABLE: 48,
			CABLE_STD: 49,
			CABLE_HRC: 50,
			CABLE_IRC: 51,
			ANALOG_PAL_BG: 64,
			ANALOG_PAL_DK: 65,
			ANALOG_PAL_I: 66,
			ANALOG_PAL_M: 67,
			ANALOG_PAL_N: 68,
			ANALOG_SECAM_BG: 69,
			ANALOG_SECAM_DK: 70,
			ANALOG_SECAM_L: 71,
			ANALOG_NTSC: 72,
			TERRESTRIAL_ATSC3: 80,
			CABLE_ATSC3: 81
		};
		idcap.channel.IpBroadcastType = {
			UNKNOWN: 0,
			UDP: 16,
			RTP: 32
		};
		idcap.channel.VideoStreamType = {
			MPEG1: 1,
			MPEG2: 2,
			MPEG4_VISUAL: 16,
			MPEG4_AVC_H264: 27,
			HEVC: 36,
			AVS: 66
		};
		idcap.channel.AudioStreamType = {
			MPEG1: 3,
			MPEG2: 4,
			MPEG2_AAC: 15,
			MPEG4_HEAAC: 17,
			AC3: 129,
			EAC3: 130,
			ANALOG_BG: 256,
			ANALOG_I: 257,
			ANALOG_DK: 258,
			ANALOG_L: 259,
			ANALOG_MN: 260,
			ANALOG_LP: 261,
			ANALOG_END: 262
		};
		idcap.channel.InbandDataServiceType = {
			UNKNOWN: 0,
			MHP: 1,
			MHEG: 2,
			HBBTV: 3,
			NONE: 4
		};
		idcap.channel.ChannelStatus = {
			UNKNOWN: 0,
			AUDIO_VIDEO_NOT_BLOCKED: 16,
			AV_DISPLAYED: 16,
			AUDIO_VIDEO_BLOCKED: 33,
			NO_SIGNAL: 33,
			AUDIO_ONLY_BLOCKED: 34,
			VIDEO_ONLY_BLOCKED: 35
		};
		idcap.channel.requestChangeCurrentChannel = function (r) {
			l("request_channel_change", r)
		};
		idcap.channel.getCurrentChannel = function (r) {
			l("get_current_channel", r)
		};
		idcap.channel.replayCurrentChannel = function (r) {
			l("replay_current_channel", r)
		};
		idcap.channel.stopCurrentChannel = function (r) {
			l("stop_current_channel", r)
		};
		idcap.channel.getDataChannel = function (r) {
			l("get_data_channel", r)
		};
		idcap.channel.getChannelMap = function (r) {
			l("get_channel_map", r)
		};
		idcap.channel.getStartChannel = function (r) {
			l("get_start_channel", r)
		};
		idcap.channel.setStartChannel = function (r) {
			l("set_start_channel", r)
		};
		idcap.channel.getCurrentChannelAudioLanguageList = function (r) {
			l("get_current_channel_audio_language_list", r)
		};
		idcap.channel.getCurrentChannelAudioLanguageIndex = function (r) {
			l("get_current_channel_audio_language_index", r)
		};
		idcap.channel.setCurrentChannelAudioLanguageIndex = function (r) {
			l("set_current_channel_audio_language_index", r)
		};
		idcap.channel.getCurrentChannelSubtitleList = function (r) {
			l("get_current_channel_subtitle_language_list", r)
		};
		idcap.channel.getCurrentChannelSubtitleIndex = function (r) {
			l("get_current_channel_subtitle_language_index", r)
		};
		idcap.channel.setCurrentChannelSubtitleIndex = function (r) {
			l("set_current_channel_subtitle_language_index", r)
		};
		idcap.channel.getProgramInfo = function (r) {
			l("get_program_info", r)
		};
		idcap.channel.launchInbandDataService = function (r) {
			l("launch_inband_data_service", r)
		};
		idcap.channel.getReadyInbandDataService = function (r) {
			l("get_ready_inband_data_service", r)
		};
		idcap.channel.getChannelSignalStatus = function (r) {
			l("get_channel_signal_status", r)
		};
		idcap.externalinput = {};
		idcap.externalinput.ExternalInputType = {
			TV: 1,
			COMPOSITE: 2,
			SVIDEO: 3,
			COMPONENT: 4,
			RGB: 5,
			HDMI: 6,
			SCART: 7,
			USB: 8,
			OTHERS: 9
		};
		idcap.externalinput.getCurrentExternalInput = function (r) {
			l("get_external_input", r)
		};
		idcap.externalinput.setCurrentExternalInput = function (r) {
			l("set_external_input", r)
		};
		idcap.externalinput.isExternalInputConnected = function (r) {
			l("check_external_input_connected", r)
		};
		idcap.externalinput.getExternalInputList = function (r) {
			l("get_external_input_list", r)
		};
		idcap.carousel = {};
		idcap.carousel.requestCacheCarouselData = function (r) {
			l("request_content", r)
		};
		idcap.carousel.isCarouselDataCached = function (r) {
			l("is_content_loaded", r)
		};
		idcap.carousel.clearCarouselDataCache = function (r) {
			l("clear_content_cache", r)
		};
		idcap.mpi = {};
		idcap.mpi.sendAndReceiveMpiData = function (r) {
			l("send_and_receive_mpi_data", r)
		};
		idcap.mpi.sendMpiData = function (r) {
			l("send_mpi_data", r)
		};
		idcap.power = {};
		idcap.power.PowerMode = {
			WARM: 2,
			NORMAL: 1
		};
		idcap.power.getPowerMode = function (r) {
			l("get_power_mode", r)
		};
		idcap.power.setPowerMode = function (r) {
			l("set_power_mode", r)
		};
		idcap.power.isWarmUpdate = function (r) {
			l("is_power_warm_update", r)
		};
		idcap.power.powerOff = function (r) {
			l("power_off", r)
		};
		idcap.power.reboot = function (r) {
			l("reboot", r)
		};
		idcap.time = {};
		idcap.time.setLocalTime = function (r) {
			l("set_tv_localtime", r)
		};
		idcap.time.getLocalTime = function (r) {
			l("get_tv_localtime", r)
		};
		idcap.time.getPowerOffTimer = function (r) {
			l("get_power_off_timer_in_min", r)
		};
		idcap.time.setPowerOffTimer = function (r) {
			l("set_power_off_timer_in_min", r)
		};
		idcap.time.getPowerOnTime = function (r) {
			l("get_power_on_time", r)
		};
		idcap.time.setPowerOnTime = function (r) {
			l("set_power_on_time", r)
		};
		idcap.time.getAlarmInformation = function (r) {
			l("get_alarm_information", r)
		};
		idcap.time.setAlarmInformation = function (r) {
			l("set_alarm_information", r)
		};
		idcap.time.getCpuTime = function (r) {
			l("get_cpu_time", r)
		};
		idcap.network = {};
		idcap.network.getNumberOfNetworkDevices = function (r) {
			l("get_number_of_network_devices", r)
		};
		idcap.network.getNetworkDevice = function (r) {
			l("get_network_device", r)
		};
		idcap.network.setNetworkDevice = function (r) {
			l("set_network_device", r)
		};
		idcap.network.ping = function (r) {
			l("ping", r)
		};
		idcap.network.NetworkEventType = {
			UNKNOWN: 0,
			ETHERNET_PLUGGED: 1,
			ETHERNET_UNPLUGGED: 2,
			WIFI_DONGLE_PLUGGED: 3,
			WIFI_DONGLE_UNPLUGGED: 4,
			IP_CONFLICT: 5,
			IP_NOT_CONFLICT: 6,
			DHCP_SUCCESS: 7,
			DHCP_FAIL: 8,
			UNABLE_REACH_GATEWAY: 9,
			ABLE_REACH_GATEWAY: 10,
			UNABLE_REACH_DNS: 11,
			ABLE_REACH_DNS: 12,
			UNABLE_REACH_INTERNET: 13,
			ABLE_REACH_INTERNET: 14,
			WIFI_AP_SEARCH_COMPLETE: 15,
			WIFI_CONNECTED: 16,
			WIFI_CONNECT_FAIL: 17,
			WIFI_LINK_DROPPED: 18
		};
		idcap.network.NetworkMode = {
			UNKNOWN: 0,
			WIRE: 1,
			WIRELESS: 2,
			NOT_REACHABLE: 3
		};
		idcap.network.WirelessMode = {
			UNKNOWN: 0,
			INFRA: 1,
			ADHOC: 2
		};
		idcap.network.WifiSecurityType = {
			UNKNOWN: 0,
			OPEN: 1,
			WEP: 2,
			WPA_PSK_TKIP: 3,
			WPA_PSK_AES: 4,
			WPA2_PSK_TKIP: 5,
			WPA2_PSK_AES: 6,
			WPA12_PSK_AES_TKIPAES: 7
		};
		idcap.network.DhcpState = {
			UNKNOWN: 0,
			INIT: 1,
			SELECTING: 2,
			REQUESTING: 3,
			BOUND: 4,
			RENEWING: 5,
			REBINDING: 6,
			INIT_REBOOT: 7,
			REBOOTING: 8
		};
		idcap.network.getNetworkInformation = function (r) {
			l("get_network_information", r)
		};
		idcap.network.getSoftAP = function (r) {
			l("get_soft_ap", r)
		};
		idcap.network.setSoftAP = function (r) {
			l("set_soft_ap", r)
		};
		idcap.network.getWifiDiagnostics = function (r) {
			l("get_wifi_diagnostics", r)
		};
		idcap.network.asyncPing = function (r) {
			l("async_ping", r)
		};
		idcap.network.setVlanIdMode = function (r) {
			l("set_vlan_id_mode", r)
		};
		idcap.network.getVlanIdMode = function (r) {
			l("get_vlan_id_mode", r)
		};
		idcap.network.getLanId = function (r) {
			l("get_lan_id", r)
		};
		idcap.network.setLanId = function (r) {
			l("set_lan_id", r)
		};
		idcap.network.getAuxLanId = function (r) {
			l("get_aux_lan_id", r)
		};
		idcap.network.setAuxLanId = function (r) {
			l("set_aux_lan_id", r)
		};
		idcap.network.getBlockedPortList = function (r) {
			l("get_blocked_port_list", r)
		};
		idcap.network.setBlockedPortList = function (r) {
			l("set_blocked_port_list", r)
		};
		idcap.mode = {};
		idcap.mode.idcap_MODE_0 = 257;
		idcap.mode.idcap_MODE_1 = 258;
		idcap.mode.idcap_MODE_2 = 259;
		idcap.mode.idcap_MODE_3 = 260;
		idcap.mode.idcap_MODE_4 = 261;
		idcap.mode.getidcapMode = function (r) {
			l("get_mw_mode", r)
		};
		idcap.mode.setidcapMode = function (r) {
			l("set_mw_mode", r)
		};
		idcap.key = {};
		idcap.key.Code = {
			NUM_0: 48,
			NUM_1: 49,
			NUM_2: 50,
			NUM_3: 51,
			NUM_4: 52,
			NUM_5: 53,
			NUM_6: 54,
			NUM_7: 55,
			NUM_8: 56,
			NUM_9: 57,
			CH_UP: 427,
			CH_DOWN: 428,
			GUIDE: 458,
			INFO: 457,
			LEFT: 37,
			UP: 38,
			RIGHT: 39,
			DOWN: 40,
			ENTER: 13,
			BACK: 461,
			EXIT: 1001,
			RED: 403,
			GREEN: 404,
			YELLOW: 405,
			BLUE: 406,
			STOP: 413,
			PLAY: 415,
			PAUSE: 19,
			REWIND: 412,
			FAST_FORWARD: 417,
			LAST_CH: 711,
			PORTAL: 602,
			ORDER: 623,
			MINUS: 704,
			POWER: 409,
			VOL_UP: 447,
			VOL_DOWN: 448,
			MUTE: 449,
			RECORD: 416,
			PAGE_UP: 33,
			PAGE_DOWN: 34,
			RF_BYPASS: 29,
			NEXT_DAY: 425,
			PREV_DAY: 424,
			APPS: 93,
			LINK: 606,
			FORWARD: 167,
			ZOOM: 251,
			SETTINGS: 611,
			NEXT_FAV_CH: 176,
			RES_1: 112,
			RES_2: 113,
			RES_3: 114,
			RES_4: 115,
			RES_5: 116,
			RES_6: 117,
			LOCK: 619,
			SKIP: 620,
			LIST: 1006,
			LIVE: 622,
			ON_DEMAND: 623,
			PINP_MOVE: 624,
			PINP_UP: 625,
			PINP_DOWN: 626,
			MENU: 18,
			AD: 700,
			ALARM: 701,
			AV_MODE: 31,
			SUBTITLE: 460,
			CC: 1008,
			DISC_POWER_OFF: 705,
			DISC_POWER_ON: 706,
			DVD: 707,
			EJECT: 414,
			ENERGY_SAVING: 709,
			FAV: 710,
			FLASHBK: 711,
			INPUT: 712,
			MARK: 713,
			NETCAST: 1000,
			PIP: 715,
			PIP_CH_DOWN: 716,
			PIP_CH_UP: 717,
			PIP_INPUT: 718,
			PIP_SWAP: 719,
			Q_MENU: 1002,
			Q_VIEW: 1007,
			RATIO: 1005,
			SAP: 723,
			SIMPLINK: 724,
			STB: 725,
			T_OPT: 1004,
			TEXT: 459,
			SLEEP_TIMER: 729,
			TV: 730,
			TV_RAD: 731,
			VCR: 732,
			POWER_LOWBATTERY: 733,
			SMART_HOME: 734,
			SCREEN_REMOTE: 735,
			POINTER: 736,
			LG_3D: 737,
			DATA: 738,
			ASSISTIVE_MENU: 739,
			THREE_DIGIT_INPUT: 740,
			LIVETV: 741,
			GOTOPREV: 742,
			GOTONEXT: 743,
			TER: 744,
			BS: 745,
			CS1: 746,
			CS2: 747,
			CS4K: 748,
			BS4K: 749,
			NUM_11: 750,
			NUM_12: 751,
			NETFLIX: 1037
		};
		g[idcap.key.Code.NUM_0] = idcap.key.Code.NUM_0;
		g[idcap.key.Code.NUM_1] = idcap.key.Code.NUM_1;
		g[idcap.key.Code.NUM_2] = idcap.key.Code.NUM_2;
		g[idcap.key.Code.NUM_3] = idcap.key.Code.NUM_3;
		g[idcap.key.Code.NUM_4] = idcap.key.Code.NUM_4;
		g[idcap.key.Code.NUM_5] = idcap.key.Code.NUM_5;
		g[idcap.key.Code.NUM_6] = idcap.key.Code.NUM_6;
		g[idcap.key.Code.NUM_7] = idcap.key.Code.NUM_7;
		g[idcap.key.Code.NUM_8] = idcap.key.Code.NUM_8;
		g[idcap.key.Code.NUM_9] = idcap.key.Code.NUM_9;
		g[idcap.key.Code.CH_UP] = idcap.key.Code.CH_UP;
		g[idcap.key.Code.CH_DOWN] = idcap.key.Code.CH_DOWN;
		g[idcap.key.Code.GUIDE] = idcap.key.Code.GUIDE;
		g[idcap.key.Code.INFO] = idcap.key.Code.INFO;
		g[idcap.key.Code.LEFT] = idcap.key.Code.LEFT;
		g[idcap.key.Code.UP] = idcap.key.Code.UP;
		g[idcap.key.Code.RIGHT] = idcap.key.Code.RIGHT;
		g[idcap.key.Code.DOWN] = idcap.key.Code.DOWN;
		g[idcap.key.Code.ENTER] = 10;
		g[idcap.key.Code.BACK] = 608;
		g[idcap.key.Code.EXIT] = 601;
		g[idcap.key.Code.RED] = idcap.key.Code.RED;
		g[idcap.key.Code.GREEN] = idcap.key.Code.GREEN;
		g[idcap.key.Code.YELLOW] = idcap.key.Code.YELLOW;
		g[idcap.key.Code.BLUE] = idcap.key.Code.BLUE;
		g[idcap.key.Code.STOP] = idcap.key.Code.STOP;
		g[idcap.key.Code.PLAY] = idcap.key.Code.PLAY;
		g[idcap.key.Code.PAUSE] = idcap.key.Code.PAUSE;
		g[idcap.key.Code.REWIND] = idcap.key.Code.REWIND;
		g[idcap.key.Code.FAST_FORWARD] = idcap.key.Code.FAST_FORWARD;
		g[idcap.key.Code.LAST_CH] = 607;
		g[idcap.key.Code.PORTAL] = idcap.key.Code.PORTAL;
		g[idcap.key.Code.ORDER] = idcap.key.Code.ORDER;
		g[idcap.key.Code.MINUS] = 45;
		g[idcap.key.Code.POWER] = idcap.key.Code.POWER;
		g[idcap.key.Code.VOL_UP] = idcap.key.Code.VOL_UP;
		g[idcap.key.Code.VOL_DOWN] = idcap.key.Code.VOL_DOWN;
		g[idcap.key.Code.MUTE] = idcap.key.Code.MUTE;
		g[idcap.key.Code.RECORD] = idcap.key.Code.RECORD;
		g[idcap.key.Code.PAGE_UP] = idcap.key.Code.PAGE_UP;
		g[idcap.key.Code.PAGE_DOWN] = idcap.key.Code.PAGE_DOWN;
		g[idcap.key.Code.RF_BYPASS] = 600;
		g[idcap.key.Code.NEXT_DAY] = 603;
		g[idcap.key.Code.PREV_DAY] = 604;
		g[idcap.key.Code.APPS] = 605;
		g[idcap.key.Code.LINK] = idcap.key.Code.LINK;
		g[idcap.key.Code.FORWARD] = 609;
		g[idcap.key.Code.ZOOM] = 610;
		g[idcap.key.Code.SETTINGS] = idcap.key.Code.SETTINGS;
		g[idcap.key.Code.NEXT_FAV_CH] = 612;
		g[idcap.key.Code.RES_1] = 613;
		g[idcap.key.Code.RES_2] = 614;
		g[idcap.key.Code.RES_3] = 615;
		g[idcap.key.Code.RES_4] = 616;
		g[idcap.key.Code.RES_5] = 617;
		g[idcap.key.Code.RES_6] = 618;
		g[idcap.key.Code.LOCK] = idcap.key.Code.LOCK;
		g[idcap.key.Code.SKIP] = idcap.key.Code.SKIP;
		g[idcap.key.Code.LIST] = 621;
		g[idcap.key.Code.LIVE] = idcap.key.Code.LIVE;
		g[idcap.key.Code.ON_DEMAND] = idcap.key.Code.ON_DEMAND;
		g[idcap.key.Code.PINP_MOVE] = idcap.key.Code.PINP_MOVE;
		g[idcap.key.Code.PINP_UP] = idcap.key.Code.PINP_UP;
		g[idcap.key.Code.PINP_DOWN] = idcap.key.Code.PINP_DOWN;
		g[idcap.key.Code.MENU] = 627;
		g[idcap.key.Code.AD] = idcap.key.Code.AD;
		g[idcap.key.Code.ALARM] = idcap.key.Code.ALARM;
		g[idcap.key.Code.AV_MODE] = 702;
		g[idcap.key.Code.SUBTITLE] = 726;
		g[idcap.key.Code.CC] = 726;
		g[idcap.key.Code.DISC_POWER_OFF] = idcap.key.Code.DISC_POWER_OFF;
		g[idcap.key.Code.DISC_POWER_ON] = idcap.key.Code.DISC_POWER_ON;
		g[idcap.key.Code.DVD] = idcap.key.Code.DVD;
		g[idcap.key.Code.EJECT] = 708;
		g[idcap.key.Code.ENERGY_SAVING] = idcap.key.Code.ENERGY_SAVING;
		g[idcap.key.Code.FAV] = idcap.key.Code.FAV;
		g[idcap.key.Code.FLASHBK] = idcap.key.Code.FLASHBK;
		g[idcap.key.Code.INPUT] = idcap.key.Code.INPUT;
		g[idcap.key.Code.MARK] = idcap.key.Code.MARK;
		g[idcap.key.Code.NETCAST] = 714;
		g[idcap.key.Code.PIP] = idcap.key.Code.PIP;
		g[idcap.key.Code.PIP_CH_DOWN] = idcap.key.Code.PIP_CH_DOWN;
		g[idcap.key.Code.PIP_CH_UP] = idcap.key.Code.PIP_CH_UP;
		g[idcap.key.Code.PIP_INPUT] = idcap.key.Code.PIP_INPUT;
		g[idcap.key.Code.PIP_SWAP] = idcap.key.Code.PIP_SWAP;
		g[idcap.key.Code.Q_MENU] = 720;
		g[idcap.key.Code.Q_VIEW] = 721;
		g[idcap.key.Code.RATIO] = 722;
		g[idcap.key.Code.SAP] = idcap.key.Code.SAP;
		g[idcap.key.Code.SIMPLINK] = idcap.key.Code.SIMPLINK;
		g[idcap.key.Code.STB] = idcap.key.Code.STB;
		g[idcap.key.Code.T_OPT] = 727;
		g[idcap.key.Code.TEXT] = 728;
		g[idcap.key.Code.SLEEP_TIMER] = idcap.key.Code.SLEEP_TIMER;
		g[idcap.key.Code.TV] = idcap.key.Code.TV;
		g[idcap.key.Code.TV_RAD] = idcap.key.Code.TV_RAD;
		g[idcap.key.Code.VCR] = idcap.key.Code.VCR;
		g[idcap.key.Code.POWER_LOWBATTERY] = idcap.key.Code.POWER_LOWBATTERY;
		g[idcap.key.Code.SMART_HOME] = idcap.key.Code.SMART_HOME;
		g[idcap.key.Code.SCREEN_REMOTE] = idcap.key.Code.SCREEN_REMOTE;
		g[idcap.key.Code.POINTER] = idcap.key.Code.POINTER;
		g[idcap.key.Code.LG_3D] = idcap.key.Code.LG_3D;
		g[idcap.key.Code.DATA] = idcap.key.Code.DATA;
		g[idcap.key.Code.ASSISTIVE_MENU] = idcap.key.Code.ASSISTIVE_MENU;
		g[idcap.key.Code.THREE_DIGIT_INPUT] = idcap.key.Code.THREE_DIGIT_INPUT;
		g[idcap.key.Code.LIVETV] = idcap.key.Code.LIVETV;
		g[idcap.key.Code.GOTOPREV] = idcap.key.Code.GOTOPREV;
		g[idcap.key.Code.GOTONEXT] = idcap.key.Code.GOTONEXT;
		g[idcap.key.Code.TER] = idcap.key.Code.TER;
		g[idcap.key.Code.BS] = idcap.key.Code.BS;
		g[idcap.key.Code.CS1] = idcap.key.Code.CS1;
		g[idcap.key.Code.CS2] = idcap.key.Code.CS2;
		g[idcap.key.Code.CS4K] = idcap.key.Code.CS4K;
		g[idcap.key.Code.BS4K] = idcap.key.Code.BS4K;
		g[idcap.key.Code.NUM_11] = idcap.key.Code.NUM_11;
		g[idcap.key.Code.NUM_12] = idcap.key.Code.NUM_12;
		g[idcap.key.Code.NETFLIX] = 752;
		idcap.key.addKeyItem = function (r) {
			r.virtualKeycode = g[r.virtualKeycode];
			l("add_key_item", r)
		};
		idcap.key.removeKeyItem = function (r) {
			l("remove_key_item", r)
		};
		idcap.key.clearKeyTable = function (r) {
			l("clear_key_table", r)
		};
		idcap.key.sendKey = function (r) {
			r.virtualKeycode = g[r.virtualKeycode];
			l("send_key", r)
		};
		idcap.mouse = {};
		idcap.mouse.isMouseVisible = function (r) {
			l("get_mouse_visible", r)
		};
		idcap.mouse.setMouseVisible = function (r) {
			l("set_mouse_visible", r)
		};
		idcap.mouse.isPointerOn = function (r) {
			l("is_pointer_on", r)
		};
		idcap.mouse.setPointerOn = function (r) {
			l("set_pointer_on", r)
		};
		idcap.mouse.getPointerPosition = function (r) {
			l("get_pointer_position", r)
		};
		idcap.mouse.setPointerPosition = function (r) {
			l("set_pointer_position", r)
		};
		idcap.mouse.clickPointer = function (r) {
			l("click_pointer", r)
		};
		idcap.mouse.setPointerSize = function (r) {
			l("set_pointer_size", r)
		};
		idcap.property = {};
		idcap.property.getHotelMode = function (r) {
			l("get_hotel_mode", r)
		};
		idcap.property.setHotelMode = function (r) {
			l("set_hotel_mode", r)
		};
		idcap.property.PicturePropertyKey = {
			BACKLIGHT: 1,
			CONTRAST: 2,
			BRIGHTNESS: 3,
			SHARPNESS: 4,
			COLOR: 5,
			TINT: 6,
			COLOR_TEMPERATURE: 7,
			ASPECT_RATIO: 8
		};
		idcap.property.getPictureProperty = function (r) {
			l("get_picture_property", r)
		};
		idcap.property.setPictureProperty = function (r) {
			l("set_picture_property", r)
		};
		idcap.property.PictureMode = {
			VIVID: 1,
			STANDARD: 2,
			ECO: 3,
			CINEMA: 4,
			SPORTS: 5,
			GAME: 6,
			PHOTO: 7,
			EXPERT_BRIGHT_ROOM: 8,
			EXPERT_DARK_ROOM: 9
		};
		idcap.property.getPictureMode = function (r) {
			l("get_picture_mode", r)
		};
		idcap.property.setPictureMode = function (r) {
			l("set_picture_mode", r)
		};
		idcap.property.getProperty = function (r) {
			l("get_property", r)
		};
		idcap.property.setProperty = function (r) {
			l("set_property", r)
		};
		idcap.property.InstallerMenuItem = {
			INSTALLER_SEQ: 0,
			POWER_MANAGE: 1,
			AC_ON: 2,
			BAND: 3,
			STRT_CHANNEL: 4,
			CHAN_LOCK: 5,
			STRT_VOLUME: 7,
			MIN_VOLUME: 8,
			MAX_VOLUME: 9,
			MUTE_DISABLE: 10,
			KEY_DEFEAT: 11,
			IR_BANKS_ENABLE: 12,
			SCAN_MODE: 13,
			STRT_CH_IN_SM: 14,
			SLEEP_TIMER: 15,
			EN_TIMER: 16,
			ALARM: 17,
			FEATURE_LEVEL: 20,
			V_CHIP: 21,
			MAX_BLK_HRS: 22,
			CAPTION_LOCK: 23,
			FUNCTION_PRE: 25,
			HOSPITAL_MODE: 27,
			CH_OVERIDE: 28,
			REMAP_AUX_INPS: 29,
			ACK_MASK: 30,
			POLL_RATE: 31,
			TIMING_PULSE: 32,
			COMPORT_EN: 34,
			HDMI1_ENABLE: 35,
			REAR_AUX_EN: 39,
			SIMPLINK_EN: 41,
			AUTO_INPUTS: 42,
			STRT_AUX_SRCE: 46,
			AUX_STATUS: 47,
			DIS_AUDIO_M: 49,
			DIS_CH_TIME: 53,
			EN_CH_T_COL: 69,
			FOR_CH_TIME: 70,
			BCK_CH_TIME: 71,
			CH_NOT_AVBLE: 73,
			REVERT_CH: 75,
			QUICK_SHUTOFF: 77,
			UPN_MSB: 78,
			UPN_MSB_1: 79,
			UPN_MSB_2: 80,
			UPN_LSB: 81,
			CHKSUM_ERROR: 82,
			HANDSHK_TIME: 83,
			PERMANENT_BLK: 84,
			V_MUTE_TIME: 86,
			REAR_RGB_EN: 87,
			EN_NOISE_MUTE: 88,
			KEY_LOCK: 90,
			HDMI2_ENABLE: 91,
			HDMI3_ENABLE: 92,
			RJP_AVAILABLE: 93,
			SAP_MENU_EN: 94,
			DEF_ASP_RATIO: 96,
			AUDIO_OUTPUT: 97,
			PROCENTRIC: 98,
			BACK_LIGHTING: 99,
			VIDEO_INTERFACE: 100,
			IR_FEEDBACK: 101,
			ATSC_BAND: 102,
			ATSC_TUNE_MODE: 103,
			START_MINOR_CH: 104,
			VID_OUT_FORMAT: 105,
			ASP_RATIO_LOCK: 106,
			BANNER_SELECT: 107,
			PANEL_COM: 108,
			PANEL_HNDSHAKE: 109,
			PANEL_DELAY: 110,
			PANEL_VOL_PRE: 111,
			PANEL_STRT_VOL: 112,
			PANEL_TYPE: 113,
			PANEL_MIN_VOL: 114,
			PANEL_MAX_VOL: 115,
			VIDEO_MUTE_EN: 116,
			FACT_DEFAULT: 117,
			POWER_SAVINGS: 118,
			DATA_CHANNEL: 119,
			UPDATE_TIME_HR: 121,
			UPDATE_TIME_MN: 122
		};
		idcap.property.getInstallerMenuItem = function (r) {
			l("get_installer_menu_item", r)
		};
		idcap.property.setInstallerMenuItem = function (r) {
			l("set_installer_menu_item", r)
		};
		idcap.Media = function () {};
		idcap.Media.startUp = function (r) {
			l("media_startup", r)
		};
		idcap.Media.shutDown = function (r) {
			l("media_shutdown", r)
		};
		idcap.Media.createMedia = function (r) {
			if (r === null) {
				return a
			}
			if (a === null && r.url !== null && r.mimeType !== null) {
				a = new idcap.Media();
				l("media_create_media", r);
				return a
			}
			return null
		};
		idcap.Media.prototype.play = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_play", r)
		};
		idcap.Media.prototype.pause = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_pause", r)
		};
		idcap.Media.prototype.resume = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_resume", r)
		};
		idcap.Media.prototype.stop = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_stop", r)
		};
		idcap.Media.prototype.destroy = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_destroy", r);
			a = null
		};
		idcap.Media.prototype.getInformation = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_get_information", r)
		};
		idcap.Media.prototype.getPlayPosition = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_get_play_position", r)
		};
		idcap.Media.prototype.setPlayPosition = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_set_play_position", r)
		};
		idcap.Media.prototype.getPlaySpeed = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_get_play_speed", r)
		};
		idcap.Media.prototype.setPlaySpeed = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_set_play_speed", r)
		};
		idcap.Media.prototype.setSubtitleOn = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_set_subtitle_on", r)
		};
		idcap.Media.prototype.getSubtitleOn = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_get_subtitle_on", r)
		};
		idcap.Media.prototype.setSubtitleUrl = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_set_subtitle_url", r)
		};
		idcap.Media.prototype.getState = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_get_state", r)
		};
		idcap.Media.prototype.getAudioLanguage = function (r) {
			l("media_get_audio_language", r)
		};
		idcap.Media.prototype.setAudioLanguage = function (r) {
			l("media_set_audio_language", r)
		};
		idcap.Media.prototype.getSubtitle = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_get_subtitle", r)
		};
		idcap.Media.prototype.setSubtitle = function (r) {
			if (a === null) {
				r.onFailure({
					errorMessage: "already destroyed."
				});
				return
			}
			l("media_set_subtitle", r)
		};
		idcap.Media.SubtitleType = {
			NONE: 0,
			INTERNAL_SUBTITLE: 1,
			EXTERNAL_SUBTITLE: 2,
			CLOSED_CAPTION: 3
		};
		idcap.rms = {};
		idcap.rms.requestRms = function (r) {
			l("request_rms", r)
		};
		idcap.socket = {};
		idcap.socket.openUdpDaemon = function (r) {
			l("open_udp_daemon", r)
		};
		idcap.socket.closeUdpDaemon = function (r) {
			l("close_udp_daemon", r)
		};
		idcap.socket.openTcpDaemon = function (r) {
			l("open_tcp_daemon", r)
		};
		idcap.socket.closeTcpDaemon = function (r) {
			l("close_tcp_daemon", r)
		};
		idcap.socket.sendUdpData = function (r) {
			l("send_udp_data", r)
		};
		idcap.drm = {};
		idcap.drm.securemedia = {};
		idcap.drm.securemedia.initialize = function (r) {
			l("secure_media_drm_initialize", r)
		};
		idcap.drm.securemedia.unregister = function (r) {
			l("secure_media_drm_unregister", r)
		};
		idcap.drm.securemedia.isRegistration = function (r) {
			l("secure_media_drm_is_registration", r)
		};
		idcap.drm.securemedia.register = function (r) {
			l("secure_media_drm_register", r)
		};
		idcap.drm.securemedia.finalize = function (r) {
			l("secure_media_drm_finalize", r)
		};
		idcap.file = {};
		idcap.file.getUsbStorageList = function (r) {
			l("get_usb_storage_list", r)
		};
		idcap.file.getUsbStorageFileList = function (r) {
			l("get_usb_storage_file_list", r)
		};
		idcap.file.downloadFileToUsb = function (r) {
			l("download_file_to_usb", r)
		};
		idcap.file.deleteUsbFile = function (r) {
			l("delete_usb_file", r)
		};
		idcap.rs232c = {};
		idcap.rs232c.BaudRate = {
			BR_UNKNOWN: 0,
			BR_110: 110,
			BR_300: 300,
			BR_600: 600,
			BR_1200: 1200,
			BR_2400: 2400,
			BR_4800: 4800,
			BR_9600: 9600,
			BR_14400: 14400,
			BR_19200: 19200,
			BR_38400: 38400,
			BR_57600: 57600,
			BR_115200: 115200,
			BR_128000: 128000,
			BR_230400: 230400,
			BR_256000: 256000,
			BR_512000: 512000,
			BR_768000: 768000,
			BR_921600: 921600,
			BR_1024000: 1024000
		};
		idcap.rs232c.DataBit = {
			BIT_UNKNOWN: 0,
			BIT_7: 7,
			BIT_8: 8
		};
		idcap.rs232c.Parity = {
			UNKNOWN: 0,
			NONE: 1,
			EVEN: 2,
			ODD: 3
		};
		idcap.rs232c.StopBit = {
			UNKNOWN: 0,
			BIT_1: 1,
			BIT_2: 2
		};
		idcap.rs232c.FlowControl = {
			UNKNOWN: 0,
			NONE: 1,
			XON_XOFF: 2,
			HARDWARE: 3
		};
		idcap.rs232c.getConfiguration = function (r) {
			l("rs232c_get_configuration", r)
		};
		idcap.rs232c.setConfiguration = function (r) {
			l("rs232c_set_configuration", r)
		};
		idcap.rs232c.sendData = function (r) {
			l("rs232c_send_data", r)
		};
		idcap.rs232c.setStartupData = function (r) {
			l("rs232c_set_teaching_data", r)
		};
		idcap.rs232c.clearStartupData = function (r) {
			l("rs232c_clear_teaching_data", r)
		};
		idcap.system = {};
		idcap.system.requestScreenCaptureImage = function (r) {
			l("request_screen_capture_image", r)
		};
		idcap.system.getScreenCaptureImage = function (r) {
			l("get_screen_capture_image", r)
		};
		idcap.system.launchidcapHtmlApplication = function (r) {
			l("launch_idcap_html_application", r)
		};
		idcap.system.getMemoryUsage = function (r) {
			l("get_memory_usage", r)
		};
		idcap.system.getCpuUsage = function (r) {
			l("get_cpu_usage", r)
		};
		idcap.system.requestFocus = function (r) {
			l("request_focus", r)
		};
		idcap.system.getFocused = function (r) {
			l("get_focused", r)
		};
		idcap.system.requestCloning = function (r) {
			l("request_cloning", r)
		};
		idcap.system.getLocaleList = function (r) {
			l("get_locale_list", r)
		};
		idcap.system.getLocale = function (r) {
			l("get_locale", r)
		};
		idcap.system.requestLocaleChange = function (r) {
			l("request_locale_change", r)
		};
		idcap.system.getProcentricServer = function (r) {
			l("get_procentric_server", r)
		};
		idcap.system.setProcentricServer = function (r) {
			l("set_procentric_server", r)
		};
		idcap.system.SoundOutputType = {
			UNKNOWN: 0,
			INTERNAL_TV_SPEAKER: 1,
			WIRED_HEADPHONES: 2,
			OFF: 3,
			OPTICAL: 4,
			OPTICAL_LGSOUNDSYNC: 5,
			EXTERNAL_ARC: 6
		};
		idcap.system.getSoundOutput = function (r) {
			l("get_sound_output", r)
		};
		idcap.system.getDefaultSoundOutput = function (r) {
			l("get_default_sound_output", r)
		};
		idcap.system.setSoundOutput = function (r) {
			l("set_sound_output", r)
		};
		idcap.system.setDefaultSoundOutput = function (r) {
			l("set_default_sound_output", r)
		};
		idcap.system.beginDestroy = function (r) {
			l("begin_destroy", r)
		};
		idcap.system.endDestroy = function (r) {
			l("end_destroy", r)
		};
		idcap.system.getAudioPtsOffset = function (r) {
			l("get_audio_pts_offset", r)
		};
		idcap.system.setAudioPtsOffset = function (r) {
			l("set_audio_pts_offset", r)
		};
		idcap.system.getVideoPtsOffset = function (r) {
			l("get_video_pts_offset", r)
		};
		idcap.system.setVideoPtsOffset = function (r) {
			l("set_video_pts_offset", r)
		};
		idcap.system.getProxyServer = function (r) {
			l("get_proxy_server", r)
		};
		idcap.system.setProxyServer = function (r) {
			l("set_proxy_server", r)
		};
		idcap.system.expireProxyServer = function (r) {
			l("expire_proxy_server", r)
		};
		idcap.system.getBrowserDebugMode = function (r) {
			l("get_browser_debug_mode", r)
		};
		idcap.system.setBrowserDebugMode = function (r) {
			l("set_browser_debug_mode", r)
		};
		idcap.system.getNoSignalImage = function (r) {
			l("get_no_signal_image", r)
		};
		idcap.system.setNoSignalImage = function (r) {
			l("set_no_signal_image", r)
		};
		idcap.system.getScreenKeyboardLanguageList = function (r) {
			l("get_screen_keyboard_language_list", r)
		};
		idcap.system.setScreenKeyboardLanguage = function (r) {
			l("set_screen_keyboard_language", r)
		};
		idcap.system.getUsbPowerControl = function (r) {
			l("get_usb_power_control", r)
		};
		idcap.system.setUsbPowerControl = function (r) {
			l("set_usb_power_control", r)
		};
		idcap.system.showToastMessage = function (r) {
			l("show_toast_message", r)
		};
		idcap.system.startManualUpdate = function (r) {
			l("start_manual_update", r)
		};
		idcap.system.cancelUpdate = function (r) {
			l("cancel_update", r)
		};
		idcap.system.getUpdateProgress = function (r) {
			l("get_update_progress", r)
		};
		idcap.checkout = {};
		idcap.checkout.requestCheckout = function (r) {
			l("request_checkout", r)
		};
		idcap.checkout.takeCheckoutSnapshot = function (r) {
			l("take_checkout_snapshot", r)
		};
		idcap.beacon = {};
		idcap.beacon.setBeaconMode = function (r) {
			l("set_beacon_mode", r)
		};
		idcap.beacon.requestiBeacon = function (r) {
			l("request_iBeacon", r)
		};
		idcap.beacon.requestEddystoneUid = function (r) {
			l("request_eddystone_uid", r)
		};
		idcap.beacon.requestEddystoneUrl = function (r) {
			l("request_eddystone_url", r)
		};
		idcap.beacon.getBeaconInformation = function (r) {
			l("get_beacon_information", r)
		};
		idcap.beacon.startScan = function (r) {
			l("beacon_start_scan", r)
		};
		idcap.beacon.stopScan = function (r) {
			l("beacon_stop_scan", r)
		};
		idcap.bluetooth = {};
		idcap.bluetooth.setScanState = function (r) {
			l("bt_gap_set_scan_state", r)
		};
		idcap.bluetooth.disconnect = function (r) {
			l("bt_service_disconnect", r)
		};
		idcap.bluetooth.setBluetoothSoundSync = function (r) {
			l("set_bt_sound_sync", r)
		};
		idcap.bluetooth.getBluetoothSoundSync = function (r) {
			l("get_bt_sound_sync", r)
		};
		idcap.bluetooth.audio = {};
		idcap.bluetooth.audio.play = function (r) {
			l("bt_audio_play", r)
		};
		idcap.bluetooth.audio.stop = function (r) {
			l("bt_audio_stop", r)
		};
		idcap.bluetooth.audio.pause = function (r) {
			l("bt_audio_pause", r)
		};
		idcap.bluetooth.audio.forward = function (r) {
			l("bt_audio_forward", r)
		};
		idcap.bluetooth.audio.backward = function (r) {
			l("bt_audio_backward", r)
		};
		idcap.webrtc = {};
		idcap.webrtc.startPreviewVideo = function (r) {
			l("webrtc_start_preview_video", r)
		};
		idcap.webrtc.stopPreviewVideo = function (r) {
			l("webrtc_stop_preview_video", r)
		};
		idcap.webrtc.incomingCall = function (r) {
			l("webrtc_incoming_call", r)
		};
		idcap.webrtc.outgoingCall = function (r) {
			l("webrtc_outgoing_call", r)
		};
		idcap.webrtc.endCall = function (r) {
			l("webrtc_end_call", r)
		};
		idcap.webrtc.acceptMessage = function (r) {
			l("webrtc_accept_message", r)
		};
		idcap.webrtc.startCheckAudio = function (r) {
			l("webrtc_start_check_audio", r)
		};
		idcap.webrtc.stopCheckAudio = function (r) {
			l("webrtc_stop_check_audio", r)
		};
		idcap.webrtc.setConfiguration = function (r) {
			l("webrtc_set_configuration", r)
		};
		idcap.webrtc.getConfiguration = function (r) {
			l("webrtc_get_configuration", r)
		};
		idcap.webrtc.showDiagnostics = function (r) {
			l("webrtc_show_diagnostics", r)
		};
		idcap.security = {};
		idcap.security.registerServerCertificate = function (r) {
			l("register_server_certificate", r)
		};
		idcap.security.registerClientCertificate = function (r) {
			l("register_client_certificate", r)
		};
		idcap.security.unregisterServerCertificate = function (r) {
			l("unregister_server_certificate", r)
		};
		idcap.security.unregisterClientCertificate = function (r) {
			l("unregister_client_certificate", r)
		};
		idcap.security.existServerCertificate = function (r) {
			l("exist_server_certificate", r)
		};
		idcap.security.existClientCertificate = function (r) {
			l("exist_client_certificate", r)
		};
		idcap.iot = {};
		idcap.iot.requestSetBridgeStatus = function (r) {
			l("iot_request_set_bridge_status", r)
		};
		idcap.iot.getBridgeStatus = function (r) {
			l("iot_get_bridge_status", r)
		};
		idcap.iot.requestRegisterThing = function (r) {
			l("iot_request_register_thing", r)
		};
		idcap.iot.requestRejectThing = function (r) {
			l("iot_request_reject_thing", r)
		};
		idcap.iot.getThingList = function (r) {
			l("iot_get_thing_list", r)
		};
		idcap.iot.getBindingIdList = function (r) {
			l("iot_get_binding_id_list", r)
		};
		idcap.iot.requestSetComponent = function (r) {
			l("iot_request_set_component", r)
		};
		idcap.iot.requestUnregisterThing = function (r) {
			l("iot_request_unregister_thing", r)
		};
		idcap.iot.setThingNickname = function (r) {
			l("iot_set_thing_nickname", r)
		};
		idcap.iot.requestSynchronizeThing = function (r) {
			l("iot_request_synchronize_thing", r)
		};
		idcap.iot.getFrameworkStatus = function (r) {
			l("iot_get_framework_status", r)
		};
		idcap.iot.requestFactoryReset = function (r) {
			l("iot_request_factory_reset", r)
		};
		idcap.iot.getVersions = function (r) {
			l("iot_get_versions", r)
		};
		idcap.iot.getThingListPrivate = function (r) {
			l("iot_get_thing_list_private", r)
		};
		idcap.camera = {};
		idcap.camera.getCameraInformation = function (r) {
			l("get_camera_information", r)
		};
		idcap.camera.getCameraControl = function (r) {
			l("get_camera_control", r)
		};
		idcap.camera.setCameraControl = function (r) {
			l("set_camera_control", r)
		};
		idcap.speech = {};
		idcap.speech.setSpeechRecognition = function (r) {
			l("set_speech_recognition", r)
		};
		idcap.speech.getSpeechRecognition = function (r) {
			l("get_speech_recognition", r)
		};
		idcap.speech.HostType = {
			NOT_SUPPORT: 0,
			APPLICATION: 1,
			TV: 2
		};
		idcap.speech.decideHost = function (r) {
			l("decide_host", r)
		}
	}
		())
};
